import React from 'react';
import { defineMessages, useIntl } from 'react-intl';

import IconButton from '@atlaskit/button/icon/button';
import InformationCircleIcon from '@atlaskit/icon/core/information-circle';

const i18n = defineMessages({
	label: {
		id: 'byline-connections.preview-panel.info-button.label',
		defaultMessage: 'About related context',
		description:
			'Accessible name of the information button in the Teamwork Graph preview panel header. Hovering it explains what the panel collects.',
	},
	tooltip: {
		id: 'byline-connections.preview-panel.info-button.tooltip',
		defaultMessage:
			// oxlint-disable-next-line eslint-core/no-restricted-syntax
			"Links and references are automatically updated here as this page gets used across your team's work.",
		description:
			'Tooltip shown on hover over the information button in the Teamwork Graph preview panel header, explaining that the connections keep themselves up to date.',
	},
});

/**
 * The preview panel header's information affordance: the description the panel body used to carry,
 * moved behind a hover. `IconButton` owns the tooltip, so the copy goes on `tooltip.content` and
 * the short accessible name stays on `label`. Stays a button with no `onClick` so keyboard users
 * reach the copy on focus.
 */
export const TeamworkGraphPreviewPanelInfoButton = (): React.JSX.Element => {
	const { formatMessage } = useIntl();

	return (
		<IconButton
			icon={InformationCircleIcon}
			label={formatMessage(i18n.label)}
			appearance="subtle"
			isTooltipDisabled={false}
			tooltip={{ content: formatMessage(i18n.tooltip) }}
			testId="teamwork-graph-preview-panel.info-button"
		/>
	);
};
